var _rect, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLoan(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 55,
    height: 56,
    fill: "none"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "loan_svg__a",
    x: 0.13,
    y: 0.135,
    width: 184.712,
    height: 185.73,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 1.197
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.01 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_197_1728"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4.021
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.19
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.0287811 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect1_dropShadow_197_1728",
    result: "effect2_dropShadow_197_1728"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    "in": "SourceAlpha",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 18
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 32.5
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.07 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    in2: "effect2_dropShadow_197_1728",
    result: "effect3_dropShadow_197_1728"
  }), /*#__PURE__*/React.createElement("feBlend", {
    "in": "SourceGraphic",
    in2: "effect3_dropShadow_197_1728",
    result: "shape"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "loan_svg__currentLayer"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#loan_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.52 3.402a10.076 10.076 0 012.8 2.834 10.692 10.692 0 011.545 3.756 93.596 93.596 0 01.205 35.953 10.368 10.368 0 01-1.496 3.717c-1.508 2.297-3.816 3.863-6.423 4.358a88.652 88.652 0 01-35.3-.131l.004-.01a10.096 10.096 0 01-3.67-1.553c-1.1-.74-2.051-1.705-2.797-2.838a10.717 10.717 0 01-1.543-3.756 93.672 93.672 0 01-.205-35.95 10.33 10.33 0 011.495-3.717c1.51-2.298 3.82-3.863 6.43-4.359a88.69 88.69 0 0135.293.136c1.302.267 2.545.797 3.662 1.56z",
    fill: "#62E6AC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M20.87 33.865h3.5M29.37 33.865h3.5M37.87 38.865v-10h-6l-8-6v6l-8-6v16M12.87 38.863h28",
    stroke: "#1FA469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.87 28.865l-1.878-13.141a.998.998 0 00-.989-.859h-2.266a1 1 0 00-.99.859L30.063 27.51",
    stroke: "#1FA469",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
export default SvgLoan;